import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivityStatisticsComponent } from './activity-statistics.component';
import { IonicModule } from '@ionic/angular';
import { TranslationModule } from '@app/app-translation.module';
import { ActivitiesOnLocationsStatisticComponentModule } from '../activities-on-locations-statistic-component/activities-on-locations-statistic.component.module';
import { ActivitiesOnAgenciesStatisticComponentModule } from '../activities-on-agencies-statistic-component/activities-on-agencies-statistic.component.module';
import { ActivitiesOnEventTypesStatisticComponentModule } from '../activities-on-event-types-statistic-component/activities-on-event-types-statistic.component.module';
import { ActivitiesOnAttendanceTypesStatisticComponentModule } from '../activities-on-attendance-types-statistic-component/activities-on-attendance-types-statistic.component.module';
import { ActivitiesOnDigibankObjectivesStatisticComponentModule } from '../activities-on-digibank-objectives-statistic-component/activities-on-digibank-objectives-statistic.component.module';
import { ActivitiesCountStatisticComponentModule } from '../activities-count-statistic-component/activities-count-statistic.component.module';
import { StatisticFilterComponentModule } from '@internal-components/statistic-components/statistic-filter-component/statistic-filter.component.module';

@NgModule({
	declarations: [ActivityStatisticsComponent],
	exports: [ActivityStatisticsComponent],
	imports: [
		CommonModule,
		IonicModule,
		TranslationModule,
		StatisticFilterComponentModule,
		ActivitiesOnLocationsStatisticComponentModule,
		ActivitiesOnEventTypesStatisticComponentModule,
		ActivitiesOnAgenciesStatisticComponentModule,
		ActivitiesOnAttendanceTypesStatisticComponentModule,
		ActivitiesOnDigibankObjectivesStatisticComponentModule,
		ActivitiesCountStatisticComponentModule,
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ActivityStatisticsComponentModule {}
